module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABM0lEQVQ4T6WSMS9DcRTFf6fV2SAGIdIYCImIxIKEwWKTDnYxGA2G0rS2vlbSGKw+gsnGBxAxaNKQoJMgQdJVRCLp5Y82fa/0tXHXc88v59xc8c+Rz79p3UTZQSwAq3g6CeP7AWk7BJa+TMYFOU10BsjYHcZg3SSGyOq2FSSYoAwM/xiuqTDFvl47ARwBi0CJCrNhZgcOJlgH9jAeyak/rH8zIGkDxHCdu6iSIC931JbjT+BW03YALANlPEZB1v4N3GbKxohwCUQwkuRU6AzwnWIX2MB4R8zg6Zxtm+SNJwp6bgQ2V3DqmsXopQiMAy8YRcQ8UKHKHHnd1CC/A5y6ZXGinAJ9gQpneJoOB7iNjI1Q5RgRb4A84Kn+rX8nqDlS1oPIIhIY9xgr5HXVXoKwJ/jUPwCsg1IR/rOOXQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fuwuxiang/fws_icon_tel.png
// module id = 7FXT
// module chunks = 1